import type CrudAction from '../crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '../crud/CrudActionType';

const TriggersPage = async () => import('../../pages/TriggersPage.vue');
const TriggerFormPage = async () => import('../../pages/TriggerFormPage.vue');

export default function getTriggersRoutes(): RouteRecordRaw[] {
  return [
    {
      component: TriggersPage,
      meta: {
        title: 'Triggers',
        useIn: ['navigation-tabs'],
      },
      name: 'triggers',
      path: '/triggers',
    },
    {
      component: TriggerFormPage,
      meta: {
        title: 'Create trigger',
      },
      name: 'create-trigger',
      path: '/triggers/create',
      props: (): {
        action: CrudAction;
      } => ({
        action: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      component: TriggerFormPage,
      meta: {
        title: 'Edit trigger',
      },
      name: 'edit-trigger',
      path: String.raw`/triggers/edit/:id(\d+)`,
      props: (
        route,
      ): {
        action: CrudAction;
      } => ({
        action: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      component: TriggerFormPage,
      meta: {
        title: 'Clone trigger',
      },
      name: 'clone-trigger',
      path: String.raw`/triggers/clone/:id(\d+)`,
      props: (
        route,
      ): {
        action: CrudAction;
      } => ({
        action: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
